import { useMemo, useState } from "react";
import { Reveal, Overline } from "./Reveal";
import StatusBadge from "./StatusBadge";
import { motion } from "framer-motion";

const FILTERS = ["All", "Wool Blend", "Cotton Satin", "Shirting", "Poly Blend", "Suiting", "Poly Viscose"];

export default function FabricVault({ products, onOpen }) {
  const [filter, setFilter] = useState("All");
  const fabrics = useMemo(() => products.filter((p) => p.category === "fabric"), [products]);
  const shown = filter === "All" ? fabrics : fabrics.filter((f) => f.subcategory === filter);
  const gridCols = shown.length % 3 === 0 ? "lg:grid-cols-3" : "lg:grid-cols-4";

  return (
    <section id="fabrics" data-testid="fabric-vault" className="bg-cream py-24 md:py-36 border-t border-charcoal/15">
      <div className="mx-auto max-w-[1600px] px-6 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          <Reveal>
            <Overline>Our Fabrics</Overline>
            <h2 className="mt-5 font-display font-black uppercase tracking-normal text-charcoal text-4xl md:text-6xl leading-[0.95]">
              Feel it before <br /> you wear it.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="flex flex-wrap gap-2">
              {FILTERS.map((f) => (
                <button
                  key={f}
                  data-testid={`fabric-filter-${f.replace(/\s/g, "-").toLowerCase()}`}
                  onClick={() => setFilter(f)}
                  className={`px-5 py-2.5 text-xs uppercase tracking-[0.12em] font-bold border transition-colors duration-300 ${
                    filter === f ? "bg-charcoal text-cream border-charcoal" : "bg-transparent text-charcoal border-charcoal/25 hover:border-toga hover:text-toga"
                  }`}
                >
                  {f}
                </button>
              ))}
            </div>
          </Reveal>
        </div>

        <div className={`mt-14 grid grid-cols-1 sm:grid-cols-2 ${gridCols} gap-px bg-charcoal/15 border border-charcoal/15`}>
          {shown.map((f, i) => (
            <motion.button
              key={f._id}
              layout
              onClick={() => onOpen(f)}
              data-testid={`fabric-card-${f._id}`}
              className="group relative bg-cream overflow-hidden text-left"
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: (i % 4) * 0.08 }}
            >
              <div className="aspect-square overflow-hidden">
                <img src={f.image} alt={f.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
              </div>
              <div className="p-6">
                <div className="mb-3"><StatusBadge status={f.status} /></div>
                <h3 className="font-display uppercase tracking-tight text-charcoal text-xl font-bold group-hover:text-toga transition-colors">{f.name}</h3>
                <p className="mt-2 text-sm text-charcoal/60 font-light">{f.subcategory}</p>
              </div>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
}
